import {InvalidContextSearchError} from './InvalidContextSearchError.js'
import {InvalidRequestSearchError} from './InvalidRequestSearchError.js'

export class SearchErrorsFactory {
  static invalidRequestSearchError = message => new InvalidRequestSearchError(message)

  static invalidContextSearchError = message => new InvalidContextSearchError(message)
}
